import React from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { PipelineStage } from '../../types';
import css from './PipelineStepper.module.scss';

interface PipelineStepperProps {
  stages: PipelineStage[];
}

/**
 * Vertical, presentational pipeline tracker. Renders the backend-supplied
 * stages verbatim (done / active / pending) — all phase logic lives upstream.
 *
 * Reads top-to-bottom as a single progress rail: completed stages fill green
 * with a check, the active stage is the haloed "you are here" pin, and upcoming
 * stages stay muted. Built to stay legible at the ~13 rows the backend can hand
 * us once a search reaches its terminal stage.
 */
const PipelineStepper: React.FC<PipelineStepperProps> = ({ stages }) => (
  <ol className={css.list} aria-label="Search progress">
    {stages.map((s) => (
      <li
        key={s.key}
        className={`${css.step} ${css[s.state]}`}
        aria-current={s.state === 'active' ? 'step' : undefined}
      >
        <span className={css.marker} aria-hidden="true">
          {s.state === 'done' ? <CheckOutlined /> : null}
        </span>
        <span className={css.label}>{s.label}</span>
      </li>
    ))}
  </ol>
);

export default PipelineStepper;
